<template>
  <div class="kr-values-editor text-medium">
    <div class="field measure-type-field field-wrapper">
      <label>Metric Type</label>
      <b-dropdown
        class="measure-by-dd flex-grow-1"
        variant="link"
        toggle-class="dropdown-field text-medium"
        menu-class="menu-shadow text-medium"
      >
        <template slot="button-content">
          <span v-if="keyResult.measureBy == 'percentage'">Percentage (%)</span>
          <span v-if="keyResult.measureBy == 'number'">Number (#)</span>
          <span v-if="keyResult.measureBy == 'boolean'">Boolean (/)</span>
          <span v-if="keyResult.measureBy == 'money'">Money ($)</span>
        </template>
        <b-dropdown-item @click="keyResult.measureBy = 'percentage'">% Percentage</b-dropdown-item>
        <b-dropdown-item @click="keyResult.measureBy = 'number'"># Number</b-dropdown-item>
        <b-dropdown-item @click="keyResult.measureBy = 'boolean'">/ Boolean</b-dropdown-item>
        <b-dropdown-item @click="keyResult.measureBy = 'money'">$ Money</b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="start-field field-wrapper">
      <div class="field">
        <label>
          Start value
          <span
            class="text-small text-secondary"
            v-if="keyResult.measureBy === 'money' || keyResult.measureBy === 'percentage'"
          >
            ({{ keyResult.measureBy === 'money' ? '$' : '%' }})
          </span>
        </label>
        <div class="input-dropdown">
          <input
            class="text-medium"
            type="text"
            placeholder="Open"
            v-if="keyResult.measureBy === 'boolean'"
            disabled
          />
          <input
            :class="{ 'errored-field': errors.start }"
            type="number"
            class="text-medium"
            v-model="keyResult.start"
            v-else
          />
        </div>
      </div>
      <div class="field-error-message">{{ errors.start && errors.start.join('.') }}</div>
    </div>
    <div class="end-field field-wrapper">
      <div class="field">
        <label>
          Target value
          <span
            class="text-small text-secondary"
            v-if="keyResult.measureBy === 'money' || keyResult.measureBy === 'percentage'"
          >
            ({{ keyResult.measureBy === 'money' ? '$' : '%' }})
          </span>
        </label>
        <input type="text" placeholder="Close" v-if="keyResult.measureBy === 'boolean'" disabled />
        <input
          :class="{ 'errored-field': errors.end }"
          v-model="keyResult.end"
          type="number"
          autocomplete="off"
          v-else
        />
      </div>
      <div class="field-error-message">{{ errors.end && errors.end.join('.') }}</div>
    </div>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'

/**
 * This component provides a form to edit kr values - measureType, start, end
 */
export default {
  name: 'KrValuesEditor',
  props: {
    kr: {},
    errors: { default: () => ({}) }
  },
  components: {
    BDropdownItem,
    BDropdown
  },
  data() {
    return {
      keyResult: { ...this.kr }
    }
  },
  watch: {
    keyResult: {
      deep: true,
      handler() {
        this.$emit('change', this.keyResult)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';
@import '~@/styles/common';
@import '~@/styles/errors';

$label-width: 110px;

.kr-values-editor {
  max-width: 260px;
}
/deep/ .weight-dd-menu {
  color: #333333;
  width: 280px;
  @extend .menu-shadow;
  padding: 25px 0;
  border-radius: 15px;
  .title,
  .info {
    font-size: 14px;
  }
  .title {
    font-weight: 600;
    color: #333333;
  }
  .info {
    color: #8a8a8a;
  }
  .dropdown-item {
    padding: 0.5rem 1.5rem;
  }
}
.input-dropdown {
  position: relative;
}
.field {
  display: flex;
  align-items: center;
}
.field-wrapper {
  margin-bottom: 14px;
}
label {
  margin-bottom: 0;
  width: $label-width;
  white-space: nowrap;
  flex-shrink: 0;
}
input {
  padding: 6px 16px;
  border: 1px solid $tertiary;
  border-radius: 20px;
  color: $primary;
  width: 100%;
  min-width: 0;
  &:focus {
    outline: none;
  }
}
.input-dropdown input {
  padding-right: 52px;
}
/deep/ .input-dropdown .dropdown-toggle {
  position: absolute;
  color: $primary;
  top: 5px;
  right: 15px;
  &:focus {
    box-shadow: none;
  }
}
.field-error-message {
  padding-left: $label-width;
}
/deep/ .dropdown-field {
  display: flex;
  align-items: center;
  border: 1px solid $tertiary;
  border-radius: 20px;
  padding: 6px 16px;
  justify-content: space-between;
  color: $primary;
  text-decoration: none;
}
</style>
